<mat-form-field appearance="fill" [style.width.%]="props?.width ?? 100">
    <mat-label>{{ props.label || 'Time format' }}</mat-label>
    <mat-select [formControl]="timeFormatControl">
        @for (format of timeFormatOptions; track format) {
            <mat-option [value]="format?.value">
                {{ format?.displayName }}
                @if (!props.skipPreview) {
                    - <small dronaDate [date]="sampleDate$ | ngrxPush" mode="time" [timeFormat]="format?.value"></small>
                }
            </mat-option>
        }
        @if (props.includeFreeFormOption) {
            <mat-option [value]="advancedFormat">Advanced - <small>Use a custom format</small></mat-option>
        }
    </mat-select>
    <mat-hint>{{ props.description || 'Format to use when displaying times.' }}</mat-hint>
</mat-form-field>
@if (isAdvancedFormat) {
    <mat-form-field>
        <mat-label>Advanced time format</mat-label>
        <input matInput [formControl]="advancedFormatControl" />
        @if (!!advancedFormatControl.errors) {
            <mat-error>
                @if (advancedFormatControl.hasError('required')) {
                    You must provide a time format.
                }
                @if (advancedFormatControl.hasError('invalidDatetimeFormat')) {
                    {{ advancedFormatControl.getError('invalidDatetimeFormat') }}
                }
            </mat-error>
        }
        @if (!props.skipPreview && advancedFormatControl.valid) {
            <mat-hint>Preview: {{ advancedFormatPreview }}</mat-hint>
        }
    </mat-form-field>
}
